import { gql } from "@apollo/client";
import { DIGITAL_WALLET_INFO } from "../fragments";

export const UPDATE_DIGITAL_WALLET = gql`
  mutation updateDigitalWallet($id: ID!, $input: DigitalWalletInput!) {
    updateDigitalWallet(id: $id, input: $input) {
      ...digitalWalletInfo
    }
  }
  ${DIGITAL_WALLET_INFO}
`;
